import BaseChart from './BaseChart';

/**
 * Range chart implementation using VChart
 */
class RangeChart extends BaseChart {
  /**
   * Get chart specification for range chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Determine if we want a range column or range area
    const isArea = this.options.type === 'area';
    const chartType = isArea ? 'rangeArea' : 'rangeColumn';
    
    // Chart specific fields
    const xField = this.options.xField || 'x';
    const yField = this.options.yField || ['min', 'max'];
    
    // Get series field for multiple ranges
    const seriesField = this.options.seriesField;
    
    // Determine if horizontal orientation is requested (for range column)
    const isHorizontal = this.options.direction === 'horizontal';
    
    return {
      type: chartType,
      data,
      xField: isArea ? xField : (isHorizontal ? yField : xField),
      yField: isArea ? yField : (isHorizontal ? xField : yField),
      seriesField,
      direction: isArea ? undefined : (this.options.direction || 'vertical'),
      
      // Styling based on chart type
      ...(isArea ? {
        // Range area specific styling
        area: {
          style: {
            fillOpacity: 0.5,
            ...this.options.areaStyle
          },
          state: {
            hover: {
              fillOpacity: 0.7
            },
            ...this.options.areaState
          }
        },
        line: {
          style: {
            lineWidth: 2,
            ...this.options.lineStyle
          },
          state: {
            hover: {
              lineWidth: 3
            },
            ...this.options.lineState
          }
        }
      } : {
        // Range column specific styling
        bar: {
          style: {
            cornerRadius: 2,
            maxWidth: this.options.maxBarWidth || 60,
            ...this.options.barStyle
          },
          state: {
            hover: {
              stroke: '#fff',
              lineWidth: 2
            },
            ...this.options.barState
          }
        }
      }),
      
      // Label configuration
      label: {
        visible: this.options.showLabels === true,
        position: this.options.labelPosition || 'top',
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter
      },
      
      // Axes configuration — auto-detect x-axis type for rangeArea
      axes: [
        {
          orient: isHorizontal ? 'left' : 'bottom',
          type: isArea ? this._detectXAxisType(xField) : 'band',
          ...this.options.xAxis
        },
        {
          orient: isHorizontal ? 'bottom' : 'left',
          type: 'linear',
          grid: {
            visible: true,
            ...this.options.gridStyle
          },
          ...this.options.yAxis
        }
      ],
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default RangeChart; 